import { render, staticRenderFns } from "./VueTelInput.vue?vue&type=template&id=211390ec&"
import script from "./VueTelInput.vue?vue&type=script&lang=js&"
export * from "./VueTelInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports